'use client';

type SurveyLanguage = 'en' | 'es';

interface LanguageSwitcherProps {
  value: SurveyLanguage;
  onChange: (language: SurveyLanguage) => void;
}

const LANGUAGES: Array<{ value: SurveyLanguage; label: string }> = [
  { value: 'en', label: 'EN' },
  { value: 'es', label: 'ES' },
];

export function LanguageSwitcher({ value, onChange }: LanguageSwitcherProps) {
  return (
    <div className="mb-4 flex items-center justify-end gap-2">
      <span className="text-sm text-muted-foreground">Language</span>
      <div className="inline-flex items-center rounded-md border border-input bg-background p-1">
        {LANGUAGES.map((language) => {
          const isActive = value === language.value;

          return (
            <button
              key={language.value}
              type="button"
              onClick={() => onChange(language.value)}
              className={`rounded px-2 py-1 text-xs font-medium transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              }`}
              aria-pressed={isActive}
            >
              {language.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
